import { get } from 'lodash';
import { createSelector } from 'reselect';
import { addDays, isAfter, parse } from 'date-fns';
import { getUnitViewPixel } from '@sparefoot/react-core/utils/tracking';

import { getFacilityFromRoute } from './facility';
import { getRecaptchaSiteKey } from './application';

export const getUnitFromRoute = createSelector(
	(state, props) => get(props, 'match.params.unitId'),
	(state) => state.units.byId,
	(unitId, units) => units[unitId],
);

export const UnitReservationFormSelector = createSelector(
	getRecaptchaSiteKey,
	(recaptchaSiteKey) => ({ recaptchaSiteKey }),
);

export default createSelector(
	getFacilityFromRoute,
	getUnitFromRoute,
	(state) => state.units.statusCode,
	(state) => state.units.loading,
	(state) => get(state.search, 'query.moveInDate'),
	(state) => state.app.baseUrl,
	(state) => state.reviews.byId,

	(facility, unit, statusCode, loading, moveInDate, baseUrl, reviews) => ({
		facility,
		unit,
		statusCode,
		loading,
		meta: { ...get(unit, 'meta', {}), canonical: baseUrl + unit?.url },
		outsideReservationWindow: moveInDate
			? isAfter(
					typeof moveInDate === 'string'
						? parse(moveInDate, 'MM/dd/yyyy', new Date())
						: moveInDate,
					addDays(new Date(), get(unit, 'reservationWindow')),
				)
			: false,
		phone: get(facility, 'phone'),
		reviews: get(facility, 'userReviews', []).map(
			(reviewId) => reviews[reviewId],
		),
		trackingPixel: getUnitViewPixel(get(unit, 'id'), get(facility, 'id')),
	}),
);
